import { AnimatedBroomIcon } from "@/components/ui/animated-icons/animated-broom-icon";
import { RockingChairIcon } from "@/components/ui/animated-icons/rocking-chair";
import { Button } from "@/components/ui/button";
import { useState } from "react";

export interface NoRowsOverlayProps {
  message: string;
  showResetButton?: boolean;
  onReset?: () => void;
}

/**
 * Presentational no-rows overlay for discovery tables.
 * Reused by articles table and narrative clusters table.
 */
export const NoRowsOverlay = ({
  message,
  showResetButton = false,
  onReset,
}: NoRowsOverlayProps) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="flex flex-col items-center justify-center h-full min-h-[200px] py-8 px-4"
      style={{ pointerEvents: "auto" }}
      aria-live="polite"
    >
      <div className="flex items-center gap-2">
        {!showResetButton && (
          <RockingChairIcon size={17} className="text-gray-600" />
        )}
        <p className="text-sm text-gray-600">{message}</p>
      </div>
      {showResetButton && onReset && (
        <Button
          variant="link"
          onPress={onReset}
          onHoverStart={() => setIsHovered(true)}
          onHoverEnd={() => setIsHovered(false)}
          className="text-sm flex items-center gap-1.5"
        >
          <AnimatedBroomIcon isHovered={isHovered} size={14} />
          Reset Filters
        </Button>
      )}
    </div>
  );
};
